import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X, Maximize2 } from "lucide-react";

// Item 13: "Open in modal" drillthrough — the target dashboard renders in a focused dialog with the
// carried context applied; the source dashboard keeps its filters, selections and scroll position.
export function DrillthroughModal({ modal, onClose }) {
  useEffect(() => {
    if (!modal) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [modal, onClose]);
  if (!modal) return null;
  return createPortal(
    <div data-testid="drillthrough-modal" role="dialog" aria-modal="true" aria-label={modal.title || "Drillthrough"}
      className="fixed inset-0 z-[1200] flex items-center justify-center bg-black/45 backdrop-blur-sm p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="w-[94vw] h-[88vh] max-w-[1600px] rounded-2xl border border-[color:var(--glass-border)] bg-[color:var(--surface)] shadow-2xl overflow-hidden flex flex-col">
        <div className="shrink-0 flex items-center gap-2 px-4 py-2 border-b border-[color:var(--glass-border)]">
          <span data-testid="drillthrough-modal-title" className="font-display text-sm text-[color:var(--ink)] truncate flex-1">{modal.title || "Details"}</span>
          <a data-testid="drillthrough-modal-open" href={modal.path ? `${modal.path}?${modal.q}` : modal.url} target="_blank" rel="noopener noreferrer"
            title="Open in a full page" className="p-1.5 rounded-lg text-[color:var(--ink-3)] hover:text-[color:var(--brand-ocean)] hover:bg-[color:var(--surface-2)]">
            <Maximize2 className="w-4 h-4" />
          </a>
          <button data-testid="drillthrough-modal-close" onClick={onClose} aria-label="Close drillthrough"
            className="p-1.5 rounded-lg text-[color:var(--ink-3)] hover:text-[color:var(--ink)] hover:bg-[color:var(--surface-2)]"><X className="w-4 h-4" /></button>
        </div>
        <iframe data-testid="drillthrough-modal-frame" title={modal.title || "Drillthrough target"} src={modal.url}
          className="flex-1 w-full border-0 bg-[color:var(--surface)]" />
      </div>
    </div>,
    document.body,
  );
}
